module.exports = __webpack_public_path__ + "img/activities-4.de9e329b.jpg";